






import { Component, Vue } from 'vue-property-decorator';
import { url } from '@tencent/ppd-base-libs';

@Component({
  components: {
  },
})
export default class CIndex extends Vue {

  public onameMap = {
    '22' : '全城街馬',
    '21' : '善導會',
    '20' : '鄰舍輔導會',
    '19' : '培幼會 PlanHK',
    '18' : '仁愛堂',
    '16' : '兒童醫健基金會',
    '15' : '愛望基金',
    '14' : '協康會',
    '12' : '地球之友',
    '11' : '苗圃行動',
    '10' : '保良局',
    '9' : '香港公益金',
    '8' : '香港小母牛',
    '7' : '護苗基金（ECSAF）',
    '6' : '惜食堂',
    '5' : '香港救助兒童會',
    '4' : '樂施會(OXFAM)',
    '3' : '東華三院',
    '2' : '奧比斯 (Orbis)',
    '1' : '聯合國兒童基金會香港委員會 (UNICEF HK)',
  }

  get btnText() {
    const oid = url.getUrlParam('oid');
    return oid && this.onameMap[oid] ?  `立即支持${this.onameMap[oid]}` : '立即前往';
  }

  get biExt() {
    return {
      fopenid: 'opened@wx.hkg',
      fuin: 'opened@wx.hkg',
      foid: url.getUrlParam('oid'),
    }
  }

  goWeixin() {
    window.location.href = 'weixin://';
  }

}
